/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field__Enum_Teachingsubjectinterest_Subject_Chemistry18Inputs */

const en__field__enum_teachingsubjectinterest_subject_chemistry18 = /** @type {(inputs: _Field__Enum_Teachingsubjectinterest_Subject_Chemistry18Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chemistry`)
};

const de__field__enum_teachingsubjectinterest_subject_chemistry18 = /** @type {(inputs: _Field__Enum_Teachingsubjectinterest_Subject_Chemistry18Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chemie`)
};

/**
* | output |
* | --- |
* | "Chemistry" |
*
* @param {_Field__Enum_Teachingsubjectinterest_Subject_Chemistry18Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field__enum_teachingsubjectinterest_subject_chemistry18 = /** @type {((inputs?: _Field__Enum_Teachingsubjectinterest_Subject_Chemistry18Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field__Enum_Teachingsubjectinterest_Subject_Chemistry18Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field__enum_teachingsubjectinterest_subject_chemistry18(inputs)
	return de__field__enum_teachingsubjectinterest_subject_chemistry18(inputs)
});
export { _field__enum_teachingsubjectinterest_subject_chemistry18 as "_field__enum_teachingSubjectInterest_SUBJECT_CHEMISTRY" }